import { createSelector } from 'reselect';
import { playerComparisonSelector } from './simple-selectors';

export const playerComparisonFiltersSelector = createSelector(
    playerComparisonSelector,
    (playerComparison) => playerComparison.filters
);
